import { ButtonNavigationBack } from "@nova/component-btn"
import { PluginActionsContext, usePluginActionsContext } from "./usePluginActionsContext"
import Image from "next/image"
import classNames from "classnames"

export const SidePanelPluginActionsNavigator = ({
    backTitle,
    layerName,
    onBack,
    children,
    className,
}: {
    backTitle: string
    layerName?: string
    onBack: () => void
} & React.HTMLAttributes<HTMLDivElement>) => {
    const { iconUrl, displayName } = usePluginActionsContext() as PluginActionsContext

    return (
        <div className={classNames("px-3 flex flex-col overflow-hidden h-full mb-2", className)}>
            <ButtonNavigationBack title={backTitle} onClick={onBack} className="self-start" />
            <div className="flex items-center mt-3 gap-2 select-none">
                {/* Plugin Image */}
                {iconUrl && (
                    <div className="w-6 h-6 shrink-0">
                        <Image
                            src={iconUrl}
                            alt=""
                            width={24}
                            height={24}
                            className="w-full h-full object-contain"
                            priority
                        />
                    </div>
                )}

                {/* Plugin Action Title */}
                <h4 className="text-gray-0 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    {`Create ${layerName || displayName}`}
                </h4>
            </div>

            {children}
        </div>
    )
}
